import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentUser, getUserUID, getFilteredUserUIDs } from '../selectors';
import { signOut } from '../actions';
import '../styles/QuizHeader.css';

class QuizHeaderMenu extends Component {
  constructor() {
    super();

    this.state = {
      showMenu: false,
    };

    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  showMenu(event) {
    event.preventDefault();

    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu(event) {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  }

  render() {
    const {
      currentUser,
      dispatch,
    } = this.props;
    return (
      <div className="flex flex-column">
        <a onClick={this.showMenu}>
          <span className="b pr2">{currentUser}</span>
          <span className="b moon-gray chevron down mt1" />
        </a>

        {
          this.state.showMenu
            ? (
              <ul
                className="fixed list header-menu bg-white ph3 pv3 ba b--light-gray bg-navy lh-solid"
                ref={(element) => {
                  this.headerDropdownMenu = element;
                }}
              >

                <li className="w-100">
                  <a onClick={() => dispatch(signOut())} className="f5 b near-white">Sign Out</a>
                </li>

                {/* TODO Add administrator check here and if true print link */}

              </ul>
            )
            : (
              null
            )
        }
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    loggedIn: state.loggedIn,
    checkedAuth: state.checkedAuth,
    currentUser: getCurrentUser(state, ownProps),
    users: getFilteredUserUIDs(state, ownProps),
    userUID: getUserUID(state, ownProps),
  };
}

export default connect(mapStateToProps)(QuizHeaderMenu);



// WEBPACK FOOTER //
// ./src/components/QuizHeaderMenu.js